export default __webpack_public_path__ + "static/Download_Web-aa64e9c39ad4b619dd8e1428d7f51693.png";